import { Button, Grid } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers-pro";
import { isAfter, isValid } from "date-fns";
import { useState } from "react";

interface Props {
  from?: Date;
  to?: Date;
  onApply: (range: [Date, Date]) => void;
  onCancel: () => void;
}

const DateRangeSelector = ({ from, to, onCancel, onApply }: Props) => {
  const [fromDate, setFromDate] = useState<Date>(() => from ?? new Date());
  const [toDate, setToDate] = useState<Date>(() => to ?? new Date());

  const isDateRangeValid = isValid(fromDate) && isValid(toDate) && !isAfter(fromDate, toDate);

  const handleApply = () => {
    if (isDateRangeValid) {
      onApply([fromDate, toDate]);
    }
  };

  return (
    <Grid
      container
      sx={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", px: 1, py: 2, gap: 1, maxWidth: "344px" }}
    >
      <DesktopDatePicker
        value={fromDate}
        onChange={(date) => date && setFromDate(date)}
        shouldDisableDate={(date) => date > toDate}
      />
      <DesktopDatePicker
        value={toDate}
        onChange={(date) => date && setToDate(date)}
        shouldDisableDate={(date) => date < fromDate}
      />
      <Button variant="text" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="contained" onClick={handleApply} disabled={!isDateRangeValid}>
        Apply
      </Button>
    </Grid>
  );
};

export default DateRangeSelector;
